import helper from "@/Helper.ts";

export const useTheme = () => {
  const { menuItems, vueFiles, components } = helper.getMenu();
  return { menuItems, vueFiles, components };
};
